module.exports = __webpack_public_path__ + "static/media/cin.3479715b.png";